/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ScheduleParticipantEntity,
} from '../models/index';
import {
    ScheduleParticipantEntityFromJSON,
    ScheduleParticipantEntityToJSON,
} from '../models/index';

export interface AddParticipantRequest {
    scheduleId: string;
    scheduleParticipantEntity: ScheduleParticipantEntity;
    sessionId?: string;
}

export interface GetParticipantsRequest {
    scheduleId: string;
    activeOnly?: boolean;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface RemoveParticipantRequest {
    scheduleId: string;
    participantId: string;
    sessionId?: string;
}

export interface ReorderParticipantsRequest {
    scheduleId: string;
    requestBody: Array<string>;
    sessionId?: string;
}

export interface UpdateParticipantRequest {
    scheduleId: string;
    participantId: string;
    scheduleParticipantEntity: ScheduleParticipantEntity;
    sessionId?: string;
}

/**
 * ScheduleParticipantsApi - interface
 * 
 * @export
 * @interface ScheduleParticipantsApiInterface
 */
export interface ScheduleParticipantsApiInterface {
    /**
     * Adds a participant to a schedule
     * @summary Add participant
     * @param {string} scheduleId Schedule ID
     * @param {ScheduleParticipantEntity} scheduleParticipantEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleParticipantsApiInterface
     */
    addParticipantRaw(requestParameters: AddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Adds a participant to a schedule
     * Add participant
     */
    addParticipant(requestParameters: AddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all participants for a schedule
     * @summary Get schedule participants
     * @param {string} scheduleId Schedule ID
     * @param {boolean} [activeOnly] Show only active participants
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleParticipantsApiInterface
     */
    getParticipantsRaw(requestParameters: GetParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves all participants for a schedule
     * Get schedule participants
     */
    getParticipants(requestParameters: GetParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Removes a participant from a schedule
     * @summary Remove participant
     * @param {string} scheduleId Schedule ID
     * @param {string} participantId Participant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleParticipantsApiInterface
     */
    removeParticipantRaw(requestParameters: RemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Removes a participant from a schedule
     * Remove participant
     */
    removeParticipant(requestParameters: RemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Changes the order of participants in the rotation
     * @summary Reorder participants
     * @param {string} scheduleId Schedule ID
     * @param {Array<string>} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleParticipantsApiInterface
     */
    reorderParticipantsRaw(requestParameters: ReorderParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Changes the order of participants in the rotation
     * Reorder participants
     */
    reorderParticipants(requestParameters: ReorderParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates a participant
     * @summary Update participant
     * @param {string} scheduleId Schedule ID
     * @param {string} participantId Participant ID
     * @param {ScheduleParticipantEntity} scheduleParticipantEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleParticipantsApiInterface
     */
    updateParticipantRaw(requestParameters: UpdateParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates a participant
     * Update participant
     */
    updateParticipant(requestParameters: UpdateParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ScheduleParticipantsApi extends runtime.BaseAPI implements ScheduleParticipantsApiInterface {

    /**
     * Adds a participant to a schedule
     * Add participant
     */
    async addParticipantRaw(requestParameters: AddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling addParticipant().'
            );
        }

        if (requestParameters['scheduleParticipantEntity'] == null) {
            throw new runtime.RequiredError(
                'scheduleParticipantEntity',
                'Required parameter "scheduleParticipantEntity" was null or undefined when calling addParticipant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/schedules/{scheduleId}/participants`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleParticipantEntityToJSON(requestParameters['scheduleParticipantEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Adds a participant to a schedule
     * Add participant
     */
    async addParticipant(requestParameters: AddParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.addParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all participants for a schedule
     * Get schedule participants
     */
    async getParticipantsRaw(requestParameters: GetParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling getParticipants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['activeOnly'] != null) {
            queryParameters['activeOnly'] = requestParameters['activeOnly'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/participants`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves all participants for a schedule
     * Get schedule participants
     */
    async getParticipants(requestParameters: GetParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a participant from a schedule
     * Remove participant
     */
    async removeParticipantRaw(requestParameters: RemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling removeParticipant().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling removeParticipant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/schedules/{scheduleId}/participants/{participantId}`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Removes a participant from a schedule
     * Remove participant
     */
    async removeParticipant(requestParameters: RemoveParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.removeParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes the order of participants in the rotation
     * Reorder participants
     */
    async reorderParticipantsRaw(requestParameters: ReorderParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling reorderParticipants().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling reorderParticipants().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/schedules/{scheduleId}/participants/reorder`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Changes the order of participants in the rotation
     * Reorder participants
     */
    async reorderParticipants(requestParameters: ReorderParticipantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.reorderParticipantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a participant
     * Update participant
     */
    async updateParticipantRaw(requestParameters: UpdateParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling updateParticipant().'
            );
        }

        if (requestParameters['participantId'] == null) {
            throw new runtime.RequiredError(
                'participantId',
                'Required parameter "participantId" was null or undefined when calling updateParticipant().'
            );
        }

        if (requestParameters['scheduleParticipantEntity'] == null) {
            throw new runtime.RequiredError(
                'scheduleParticipantEntity',
                'Required parameter "scheduleParticipantEntity" was null or undefined when calling updateParticipant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/schedules/{scheduleId}/participants/{participantId}`;
        urlPath = urlPath.replace(`{${"scheduleId"}}`, encodeURIComponent(String(requestParameters['scheduleId'])));
        urlPath = urlPath.replace(`{${"participantId"}}`, encodeURIComponent(String(requestParameters['participantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleParticipantEntityToJSON(requestParameters['scheduleParticipantEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates a participant
     * Update participant
     */
    async updateParticipant(requestParameters: UpdateParticipantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateParticipantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
